import * as React from "react";

const SvgRule = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 4.5H5C4.72386 4.5 4.5 4.72386 4.5 5V15C4.5 15.2761 4.72386 15.5 5 15.5H15C15.2761 15.5 15.5 15.2761 15.5 15V5C15.5 4.72386 15.2761 4.5 15 4.5ZM5 3C3.89543 3 3 3.89543 3 5V15C3 16.1046 3.89543 17 5 17H15C16.1046 17 17 16.1046 17 15V5C17 3.89543 16.1046 3 15 3H5ZM0.75 4C0.335786 4 0 4.33579 0 4.75V15.25C0 15.6642 0.335786 16 0.75 16C1.16421 16 1.5 15.6642 1.5 15.25V4.75C1.5 4.33579 1.16421 4 0.75 4ZM19.25 4C18.8358 4 18.5 4.33579 18.5 4.75V15.25C18.5 15.6642 18.8358 16 19.25 16C19.6642 16 20 15.6642 20 15.25V4.75C20 4.33579 19.6642 4 19.25 4ZM6.75 6C6.33579 6 6 6.33579 6 6.75C6 7.16421 6.33579 7.5 6.75 7.5H13.25C13.6642 7.5 14 7.16421 14 6.75C14 6.33579 13.6642 6 13.25 6H6.75ZM6.75 9.19995C6.33579 9.19995 6 9.53574 6 9.94995C6 10.3642 6.33579 10.7 6.75 10.7H13.25C13.6642 10.7 14 10.3642 14 9.94995C14 9.53574 13.6642 9.19995 13.25 9.19995H6.75ZM6 13.1499C6 12.7357 6.33579 12.3999 6.75 12.3999H13.25C13.6642 12.3999 14 12.7357 14 13.1499C14 13.5641 13.6642 13.8999 13.25 13.8999H6.75C6.33579 13.8999 6 13.5641 6 13.1499Z"
      fill="#BABABA"
    />
  </svg>
);

export default SvgRule;
